import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../redux/actions';
import FieldAllowanceRequestTable from '../../components/Table/FieldAllowanceRequestTable';
import AddFieldAllowanceRequest from './AddFieldAllowanceRequest';
import { confirmAsync } from '../../utils/functions/globalDialog';

export default function FieldAllowanceRequestList({ title, subtitle }) {
  const dispatch = useDispatch();

  const me = useSelector((state) => state.me);
  const faRequests = useSelector((state) => state.fieldAllowanceRequestOrder);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [addOpen, setAddOpen] = useState(false);

  const refetch = () => dispatch(actions.fieldAllowanceRequestOrderAll({ me: me?.userData?.id }));

  useEffect(() => {
    refetch();
    return () => {};
  }, [me?.userData?.id]);

  const handleDelete = async (id) => {
    const confirm = await confirmAsync('ยืนยันลบคำขอค่าออกสนาม ใช่หรือไม่ ?');
    if (confirm) {
      dispatch(actions.fieldAllowanceRequestOrderDelete(id)).then(() => {
        refetch();
      });
    }
  };

  return (
    <div>
      <div className="flex justify-end p-1">
        <Button variant="contained" onClick={() => setAddOpen(true)} color="primary">
          ขอค่าออกสนาม
        </Button>
      </div>
      <FieldAllowanceRequestTable
        faRequest={faRequests}
        page={page}
        setPage={setPage}
        size={size}
        setSize={setSize}
        handleDelete={handleDelete}
      />
      <AddFieldAllowanceRequest
        open={addOpen}
        onClose={() => setAddOpen(false)}
        onCreated={refetch}
      />
    </div>
  );
}
